
const PROMO_VISIBILITY_DEFAULT = { top: 100, bottom: 100 };
const PROMO_VISIBILITY_OVERRIDES = {
  '#products': { top: 50, bottom: -450 }
};

function getPromoVisibilityThresholds(hash) {
  return PROMO_VISIBILITY_OVERRIDES[hash] || PROMO_VISIBILITY_DEFAULT;
}

function computePromoHashVisibility(hash, element) {
  if (!hash) {
    return false;
  }

  const target = element || document.querySelector(hash);
  if (!target) {
    return false;
  }

  const { top, bottom } = getPromoVisibilityThresholds(hash);
  const rect = target.getBoundingClientRect();

  return rect.top <= window.innerHeight - top && rect.bottom >= bottom;
}

(function ($) {
  const promo_active_class = 'promo-active'; // Class applied to active nav links and their parent items
  const products_hash = '#products';
  const hash_visibility = window.__promoHashVisibility || {}; // Tracks which hash-linked sections are currently visible
  window.__promoHashVisibility = hash_visibility;
  let manual_hash_active = null; // Tracks manually clicked hash links

  // Normalize URL path by removing trailing slash (except for root)
  function normalizePath(path) {
    return (!path || path === '/') ? '/' : path.replace(/\/$/, '');
  }

  // Get the promo menu container
  function getMenu() {
    return $('.promo-menu');
  }

  // Find a nav-link that matches a given hash (e.g. #section1)
  function findLinkByHash($menu, hash) {
    return hash ? $menu.find(`.nav-link[href="${hash}"], .nav-link[href$="${hash}"]`).first() : $();
  }

  // Find a nav-link that matches the current path or its parent
  function findLinkByPath($menu, currentPath) {
    let exactMatch = null;
    let bestParentMatch = null;
    let bestParentLength = 0;

    $menu.find('.nav-link').each(function () {
      const href = this.getAttribute('href');
      if (!href || href.startsWith('#')) {
        return;
      }

      const linkPath = normalizePath(new URL(href, window.location.origin).pathname);

      if (linkPath === currentPath) {
        exactMatch = $(this);
        return false; // break out of .each
      }

      if (currentPath.startsWith(linkPath + '/') && linkPath.length > bestParentLength) {
        bestParentMatch = $(this);
        bestParentLength = linkPath.length;
      }
    });

    return exactMatch || bestParentMatch || $();
  }

  // Apply the promo-active class to the appropriate nav-link and its parent
  function applyActiveClass() {
    const $menu = getMenu();
    if (!$menu.length) return;

    const currentPath = normalizePath(window.location.pathname);

    if (manual_hash_active && !isHashVisible(manual_hash_active)) {
      manual_hash_active = null;
    }

    const productsElement = document.querySelector(products_hash);
    if (productsElement) {
      hash_visibility[products_hash] = computePromoHashVisibility(products_hash, productsElement);
    }

    let $target = manual_hash_active ? findLinkByHash($menu, manual_hash_active) : $();

    // If no manual hash, check for visible hash section
    if (!$target.length) {
      const visibleHash = Object.keys(hash_visibility).find(h => hash_visibility[h]);
      if (visibleHash) $target = findLinkByHash($menu, visibleHash);
    }

    // If no hash match, fallback to path match
    if (!$target.length) {
      $target = findLinkByPath($menu, currentPath);
    }

    if ($target.length) {
      const href = $target.attr('href') || '';
      const hashFromLink = href.includes('#') ? (href.startsWith('#') ? href : href.substring(href.indexOf('#'))) : null;
      if (hashFromLink === products_hash && !isHashVisible(products_hash)) {
        $target = $();
      }
    }

    // Remove existing active classes from all nav-links and nav-items
    $menu.find('.nav-link, .nav-item').removeClass(promo_active_class, 'active', 'is-active');

    // Apply active class to matched link and its parent nav-item
    if ($target.length) {
      $target.addClass(promo_active_class);
      $target.closest('.nav-item').addClass(promo_active_class);
    }
  }

  // Observe hash-linked sections to track visibility in viewport
  function setupHashObservers() {
    const $menu = getMenu();
    if (!$menu.length || typeof IntersectionObserver === 'undefined') return;

    const hashes = new Set();

    // Collect all hash fragments from nav links
    $menu.find('.nav-link').each(function () {
      const href = this.getAttribute('href');
      if (href && href.includes('#')) {
        const hash = href.startsWith('#') ? href : href.substring(href.indexOf('#'));
        hashes.add(hash);
      }
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const hash = '#' + entry.target.id;
        const isVisible = computePromoHashVisibility(hash, entry.target);
        hash_visibility[hash] = isVisible;

        // Clear manual override if section is no longer visible
        if (!isVisible && manual_hash_active === hash) {
          manual_hash_active = null;
        }
      });

      applyActiveClass();
    }, {
      rootMargin: '-100px 0px -100px 0px' // Trigger slightly before/after full visibility
    });

    // Observe each hash-linked section
    hashes.forEach(hash => {
      const el = document.getElementById(hash.substring(1));
      hash_visibility[hash] = false;
      if (el) observer.observe(el);
    });
  }

  // Handle clicks on nav links to manually set active hash
  function handleClick(event) {
    const href = this.getAttribute('href') || '';
    manual_hash_active = href.includes('#') ? (href.startsWith('#') ? href : href.substring(href.indexOf('#'))) : null;
    applyActiveClass();
  }

  // Initialize the promo menu behavior
  function init() {
    // Only activate on /toddynho path
    if (!/^\/toddynho(\/|$)/.test(window.location.pathname)) return;

    const $menu = getMenu();
    if (!$menu.length) return;

    // Remove any pre-existing active classes on page load
    $menu.find('.nav-link, .nav-item').removeClass('active is-active promo-active');

    setupHashObservers();
    applyActiveClass();

    // Reapply logic after AJAX loads
    $(document)
      .off('.promoMenu')
      .on('ajaxComplete.promoMenu', () => {
        setupHashObservers();
        applyActiveClass();
      })
      .on('click.promoMenu', '.promo-menu .nav-link', handleClick);

    // React to hash changes and window resizes
    $(window)
      .off('.promoMenu')
      .on('hashchange.promoMenu', () => {
        manual_hash_active = window.location.hash || null;
        applyActiveClass();
      })
      .on('resize.promoMenu', applyActiveClass)
      .on('scroll.promoMenu', applyActiveClass);
  }

  // Run init on DOM ready
  $(init);
})(jQuery);

function isHashVisible(hash) {
  const hash_visibility = window.__promoHashVisibility || {};
  if (!hash) {
    return false;
  }

  const result = computePromoHashVisibility(hash);

  if (Object.prototype.hasOwnProperty.call(hash_visibility, hash)) {
    hash_visibility[hash] = result;
  }

  return result;
}



var scrollY = 0;
function lock() {
  scrollY = window.scrollY || window.pageYOffset;
  document.body.style.position = 'fixed';
  document.body.style.width = '100%';
  document.body.style.top = -scrollY + 'px';
  document.documentElement.style.overflow = 'hidden'; // For iOS
}
function unlock() {
  document.body.style.position = '';
  document.body.style.width = '';
  document.body.style.top = '';
  document.documentElement.style.overflow = '';
  window.scrollTo(0, scrollY);
}

// Bootstrap modals
document.addEventListener('show.bs.modal', lock);
document.addEventListener('hidden.bs.modal', unlock);

// Cookie popup open
document.addEventListener("click", (e) => {
  if (e.target.closest('.cookiesjsr-settings')) {
    lock();

    // Now the modal wrapper should exist
    setTimeout(() => {
      const cookieModal = document.querySelector('.cookiesjsr-layer--wrapper');

      if (cookieModal) {
        // Delegate close actions inside the modal
        cookieModal.addEventListener('click', (evt) => {
          if (
            evt.target.closest('.cookiesjsr-layer--close') ||
            evt.target.closest('.cookiesjsr-layer--overlay') ||
            evt.target.closest('.cookiesjsr-btn.denyAll') ||
            evt.target.closest('.cookiesjsr-btn.allowAll') ||
            evt.target.closest('.cookiesjsr-btn.save')
          ) {
            unlock();
          }
        });
      }
    }, 500); // wait a bit for modal to render
  }
});

// Esc key
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    unlock();
  }
});


